<div class="contact-name" [class.default-styling]="defaultStyling()" *ngIf="contact?.fullName">
  <svg-icon
    [src]="'/assets/img/' + (contact.type === ContactType.COMPANY ? 'ic-company-tower' : 'ic-user') + '.svg'"
    [svgStyle]="svgConfig"
  />
  <div
    class="contact-name__title"
    [matTooltip]="contact?.fullName || ''"
    matTooltipPosition="above"
    matTooltipShowDelay="1000"
  >
    <span class="pii">{{ contact?.fullName }}</span>
  </div>
</div>
